import axios from 'axios';
import { eventBus, EVENTS } from '../index';
import resource from '../../../../resources/resource';
import { Util } from '../index';
import get from 'lodash/get';

const config = {
    baseURL: resource.baseURL
};

const RepositoryWithLoading = axios.create(config);
const RepositoryNotLoading = axios.create(config);

const authInterceptor = config => {
    config = {
        ...config,
        headers: Util.getAuth()
    };

    return config;
};

const loadingInterceptor = config => {
    eventBus.$emit(EVENTS.show_loading);
    return config;
};

const responseSuccessInterceptor = response => {
    eventBus.$emit(EVENTS.hide_loading);
    return response
};

const responseErrorInterceptor = error => {
    eventBus.$emit(EVENTS.hide_loading);
    const status = error.response.status;
    if (status === 401) {
        eventBus.$emit(EVENTS.unauthorized_error);
    } else if (status === 404){
        eventBus.$emit(EVENTS.common_error, get(error, 'response.data.message', 'Đã có lỗi xảy ra. Quý khách thử lại sau'));
    } else {
        eventBus.$emit(EVENTS.server_error, 'Đã xảy ra lỗi bất ngờ. Quý khách thử lại sau');
    }
    return Promise.reject(error);
};


RepositoryWithLoading.interceptors.request.use(authInterceptor);
RepositoryWithLoading.interceptors.request.use(loadingInterceptor);
RepositoryWithLoading.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

RepositoryNotLoading.interceptors.request.use(authInterceptor);
RepositoryNotLoading.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);
export {RepositoryNotLoading, RepositoryWithLoading};
